//imports
import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Toolbar,
  Snackbar,
  Stack,
  Alert,
  Breadcrumbs,
  Link,
  AppBar,
  Divider, // Import Alert
} from "@mui/material";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Navbar from '../../components/common/Navbar';
import { Reportdata1 } from "../reports/ReportData"; // Import dataset
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../assets/styles/Theme";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
const rows = [
  { id: 1, name: 'John Doe', rating: 4.5, country: 'USA', dateCreated: '2024-01-01', isAdmin: true },
  { id: 2, name: 'Jane Smith', rating: 3.8, country: 'Canada', dateCreated: '2023-12-15', isAdmin: false },
  { id: 3, name: 'Alice Johnson', rating: 4.9, country: 'UK', dateCreated: '2023-11-20', isAdmin: true },
  { id: 4, name: 'Bob Brown', rating: 4.2, country: 'Australia', dateCreated: '2023-10-05', isAdmin: false },
  // Add more rows as needed
];

const startOfMonth = dayjs().startOf("month");

const endOfMonthDate = dayjs().endOf("month");

export default function ReportGrid() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);

  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, LOCCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const [fromDate, setFromDate] = useState(startOfMonth);
  const [toDate, setToDate] = useState(endOfMonthDate);



 const handleDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setFromDate(dayjs(formattedDate));
    } else {
      setFromDate(""); // Handle null case
    }
  };

  const handleToDateChange = (newValue) => {
    if (newValue) {
      // Format the date to YYYY-MM-DD before sending to API
      const formattedDate = newValue.format("MM/DD/YYYY");
      setToDate(dayjs(formattedDate));
    } else {
      setToDate(""); // Handle null case
    }
  };

  const gotToView = () => {
    navigate("/Reports");
  };

  return (
    <div style={{ height: 400, width: '100%', }}>
          <Navbar />
          <AppBar sx={styles.AI_CustomAppBar1}>
     
      </AppBar>
      <Box mt={15} ml={13} mr={4}>
        {/* <Grid container spacing={1}> */}
        {/* First Row: Back Button */}

        {/* Second Row: Select Location, From Date, To Date, Report Button */}
        <Grid container spacing={3} mr={15} mt={3}>
         

          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="From Date"
                value={fromDate}
                onChange={handleDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={2}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="To Date"
                value={toDate}
                onChange={handleToDateChange}
                inputFormat="MM/DD/YYYY"
                slotProps={{
                  textField: {
                    sx: {
                      width: "100%",
                      "& .MuiInputBase-root": {
                        height: "40px",
                      },
                      "& .MuiInputAdornment-root .MuiIconButton-root": {
                        color: theme.palette.primary.main, // Change icon color here
                      },
                    },
                  },
                  popper: {
                    sx: {
                      "& .MuiPaper-root": {
                        backgroundColor: theme.palette.background.paper, // Background color of the popper
                        boxShadow: "none", // Remove box shadow if needed
                      },
                    },
                  },
                }}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} md={8} sx={{ ...styles.right_align }}>
            <Button
              variant="contained"
              color="primary"
             // onClick={fetchReportDetails}
              startIcon={<SettingsSuggestIcon />}
              disabled={isLoading}
              sx={{
                // ...styles.AI_fixedStack1,
                direction: "row",
                justifyContent: "flex-end",
                background: theme.palette.primary.main,
                color: theme.palette.text.buttontxt,
                textTransform: "capitalize",
                letterSpacing: "1px",
                width: "120px",
              }}
            >
              {isLoading ? <CircularProgress size={24} /> : "Generate"}
            </Button>
          </Grid>
        </Grid>
        {/* </Grid> */}
      </Box>
      <DataGrid
      sx={{ml:13,mt:4,mr:3,
        
       } }
        rows={rows}
        columns={Reportdata1.columns}
        slots={{ toolbar: GridToolbar }}
        loading={false} // Set this to true if data is being fetched asynchronously
        checkboxSelection
        disableRowSelectionOnClick
      />
    </div>
  );
}
